var render = function render(){var _vm=this,_c=_vm._self._c;return _c(_vm.isExternalLinkFlag ? 'a' : 'nuxt-link',_vm._b({tag:"component",staticClass:"award_image"},'component',_vm.linkAttributes,false),[_c('picture',{directives:[{name:"full-image-path",rawName:"v-full-image-path:assets",value:(_vm.picture),expression:"picture",arg:"assets"}]})])
}
var staticRenderFns = []

export { render, staticRenderFns }